import { ref } from 'vue';

const TOAST_DURATION_MS = 6000;

const toasts = ref([]);
let nextId = 1;
const timeouts = new Map();

export function useToast() {
  function addToast(type, messageOrPayload) {
    const id = nextId++;
    const payload =
      typeof messageOrPayload === 'object' && messageOrPayload !== null && 'title' in messageOrPayload && 'message' in messageOrPayload
        ? { title: messageOrPayload.title, message: messageOrPayload.message }
        : { message: typeof messageOrPayload === 'string' ? messageOrPayload : String(messageOrPayload) };
    toasts.value.push({ id, type, ...payload });

    const timeoutId = setTimeout(() => {
      dismiss(id);
      timeouts.delete(id);
    }, TOAST_DURATION_MS);
    timeouts.set(id, timeoutId);

    return id;
  }

  function showSuccess(messageOrPayload) {
    return addToast('success', messageOrPayload);
  }

  function showWarning(messageOrPayload) {
    return addToast('warning', messageOrPayload);
  }

  function showError(messageOrPayload) {
    if (!navigator.onLine) {
      return null;
    }
    return addToast('error', messageOrPayload);
  }

  function dismiss(id) {
    const timeoutId = timeouts.get(id);
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeouts.delete(id);
    }
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return {
    toasts,
    showSuccess,
    showWarning,
    showError,
    dismiss,
  };
}
